import { useEffect } from 'react';
import { getDefaultBreadcrumb } from 'chameleon/src/components/results/utils/utils';

const useBreadcrumbNavigation = (router, dispatch, breadCrumbs, ACTIONS) => {
  useEffect(() => {
    const onClick = () => {
      const firstBreadcrumb =
        (breadCrumbs.length > 0 && breadCrumbs[0]) ||
        getDefaultBreadcrumb(router?.params?.subject);
      if (firstBreadcrumb) {
        if (router?.location?.state?.focusedElement) {
          router.push({
            pathname: firstBreadcrumb.to,
            state: { focusedElement: router?.location?.state?.focusedElement },
          });
        } else {
          router.push(firstBreadcrumb.to);
        }
      }
      dispatch({
        type: ACTIONS.removeAdjacentBreadCrumbs,
        payload: firstBreadcrumb.text,
      });
    };

    const onGoBackClick = () => {
      onClick();
    };

    const removeListener = () => {
      window.removeEventListener('popstate', onGoBackClick);
    };

    window.addEventListener('popstate', onGoBackClick);

    return removeListener;
  }, [router, dispatch, breadCrumbs]);

  return null;
};

export default useBreadcrumbNavigation;
